export default {
  version: '1.0.0',
}
